export default __webpack_public_path__ + "static/media/173.c36740b8.png";